import { useBrowserAgentSearchModeEnabled } from '#pplx/frontend/apps/ask/hooks/comet-hooks/useBrowserAgentSearchModeEnabled.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback } from 'react';
export function useIsModeDisabledByIncognito() {
    const { isDisabledByIncognito: isBrowserAgentDisabledByIncognito } = useBrowserAgentSearchModeEnabled();
    return useCallback((mode) => {
        switch (mode) {
            case SearchMode.BROWSER_AGENT:
                return isBrowserAgentDisabledByIncognito;
            default:
                return false;
        }
    }, [isBrowserAgentDisabledByIncognito]);
}
//# sourceMappingURL=useIsModeDisabledByIncognito.js.map